import { Component, ElementRef, inject, viewChildren } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ViewportEnterDirective } from "../viewport-enter-directive";
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-questions',
  standalone: true,
  imports: [RouterLink, ViewportEnterDirective],
  templateUrl: './questions.html',
  styleUrl: './questions.scss',
})
export class Questions {
  questionList = viewChildren<ElementRef>('question');
    activeRoute= inject(ActiveRoute);

  openQuestion(n:number){
    
    this.questionList().forEach((question,index) => {
      question as ElementRef;
      if(index !==n) 

        question.nativeElement.open=false      
      
      
      
    });
    
  }
}
